module.exports = "/images/fototipos.png?0efbcd12700d2ff487394a89a93c063f";